export default __webpack_public_path__ + "static/media/why-choose.9a7b8bf4.svg";